import Nav from 'react-bootstrap/esm/Nav';
import { Link } from 'react-router';
import { ImageGallery } from './ImageGallery';
import { Col, Row } from 'react-bootstrap';

const boxStyle = {
    backgroundImage: `linear-gradient(rgba(34, 55, 88, 0.5), rgba(43, 12, 21, 0.5))`,
    padding: '1em',
    borderRadius: '1px',
    height:'fit-content'
};

export const Home = () => {

    return (
        <div className="text-light" style={{ marginBottom:'10em', marginTop: '5em'}}>
            <Row style={boxStyle} class="justify-content-center align-items-center">
                <Col xl={7}>
                    <h1 style={{paddingBottom: '0.5em', paddingTop:'1em'}}>Vermont Automotive Technician Training Program</h1>
                    <h2 style={{paddingBottom:'1em'}}>Welcome to the online training registration portal for Vermont automotive technicians</h2>
                    <p style={{paddingBottom:'2em'}} className="lead">
                        The Vermont Automotive Technician Training Program (VATTP) provides Vermont automotive technicians with information and 
                        training classes on diagnosing and repairing vehicle emissions-related faults. The goals of the program include helping 
                        technicians efficiently and effectively diagnose and repair vehicles, while also helping to protect and improve Vermont's 
                        air quality. VATTP trainings provide theory and hands-on skills in understanding On-Board Diagnostics (OBD), diagnosing 
                        problems detected by OBD systems, and verifying repairs. The program continues to develop classes to meet the needs of 
                        Vermont technicians and provides high quality training at a number of locations around Vermont. 
                    </p>
                    <hr className="border"/>
                    <Nav variant="underline" style={{marginTop:'2em'}}>
                        <Nav.Item className="me-3 h5">
                            <Nav.Link as={Link} to="/available"  className="text-light">AVAILABLE COURSES</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="h5">
                            <Nav.Link as={Link} to="/upcoming" className="text-light" >UPCOMING COURSES</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                
            
                <Col xl={5} lg={12} className="d-sm-block d-none flex-column justify-content-center align-items-center">
                    <ImageGallery 
                         style={{height: '100%', maxHeight: '800px'}}
                    />
                </Col>
            </Row>
            
        </div>
    );
};